import { createApiMutation, createApiQuery } from '@/features/api'
import type { OutletFormDto } from '@/features/outlet/components/outlet-form'
import type { SupplierFormDto } from '@/features/outlet/components/outlet-supplier-form'

import type { IOutlet } from './type'

/* -------------------------------- OUTLET KEY -------------------------------- */

export const OUTLET_KEY = {
	// MASTER
	LIST: '/outlet/list',
	DETAIL: '/outlet/detail',
	CREATE: '/outlet/create',
	UPDATE: '/outlet/update',

	// SUPPLIER
	SUPPLIER_LIST: '/outlet/supplier/list',
	SUPPLIER_DETAIL: '/outlet/supplier/detail',
	SUPPLIER_CREATE: '/outlet/supplier/create',
	SUPPLIER_UPDATE: '/outlet/supplier/update',
}

/* --------------------------------- MASTER --------------------------------- */

export const outletMasterList = createApiQuery<{
	params: never
	result: { outlets: IOutlet[]; total: number }
}>(OUTLET_KEY.LIST)

export const outletMasterDetail = createApiQuery<{
	params: { id: string }
	result: { outlet: IOutlet }
}>(OUTLET_KEY.DETAIL)

export const outletMasterCreate = createApiMutation<{
	body: OutletFormDto
	result: { id: string }
}>(OUTLET_KEY.CREATE, { method: 'post' })

export const outletMasterUpdate = createApiMutation<{
	body: OutletFormDto & { id: string }
	result: { id: string }
}>(OUTLET_KEY.UPDATE, { method: 'put' })

/* --------------------------- API OUTLET SUPPLIER -------------------------- */

const supplierList = createApiQuery<{}, { suppliers: Array<IOutlet> }>(
	OUTLET_KEY.SUPPLIER_LIST
)

const supplierDetail = createApiQuery<{ id: string }, { supplier: IOutlet }>(
	OUTLET_KEY.SUPPLIER_DETAIL
)

const supplierCreate = createApiMutation<SupplierFormDto, {}>(
	OUTLET_KEY.SUPPLIER_CREATE,
	'post'
)

const supplierUpdate = createApiMutation<SupplierFormDto & { id: string }, {}>(
	OUTLET_KEY.SUPPLIER_UPDATE,
	'put'
)

export {
	// API Supplier
	supplierList,
	supplierDetail,
	supplierCreate,
	supplierUpdate,
}
